import request from '@/utils/request'

function QUERY( {key, params}) {
  let url
  // 获取客户信息
  if(key=='getCustomerInfo'){
    url = '/h5/CustomerInfo/index'
  }
  // 客户信息-资料设置页
  if(key=='getDataSet'){
    url = '/h5/CustomerInfo/getDataSet'
  }
  // 客户信息-资料设置页-黑名单开关
  if(key=='starmarkSwitch'){
    url = '/h5/CustomerInfo/starmarkSwitch'
  }
  // 客户信息-资料设置页-黑名单开关
  if(key=='blacklistSwitch'){
    url = '/h5/CustomerInfo/blacklistSwitch'
  }
  // 客户信息-资料设置页-删除客户信息
  if(key=='delCustomerInfo'){
    url = '/h5/CustomerInfo/delCustomerInfo'
  }
  // 客户信息页-获取设置备注和描述
  if(key=='getRemarkDesc'){
    url = '/h5/CustomerInfo/getRemarkDesc'
  }
  // 客户信息页-保存设置备注和描述
  if(key=='saveRemarkDesc'){
    url = '/h5/CustomerInfo/saveRemarkDesc'
  }
  // 
  if(key=='uploadOss'){
    url = '/h5/CustomerInfo/uploadOss'
  }
  

  if (typeof params == 'object') {
    params['version'] = 'MINI'
  } else {
    params = { version: 'MINI' }
  }
  return request({
    url,
    method: 'post',
    params
  })
}

export default QUERY;